import {useEffect, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {Skeleton, Stack} from '@mui/material';
import {Grid} from "@material-ui/core";

am4core.useTheme(am4themes_animated);

const ChartEight = ({ data, name, className, height = '180px' }) => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setShowLoader(true);
        if (data.data.length) {
            for (let i = 0; i < data.data.length; i++) {
                const chart = am4core.create(name + i, am4charts.PieChart);

                chart.events.on('ready', () => {
                    setShowLoader(false);
                });

                const colors = [
                    am4core.color("#6794dc"),
                    am4core.color("#008080"),
                    am4core.color("#dc6967"),
                    am4core.color("#FFA500"),
                ];

                chart.data = Object.entries(data.data[i])
                    .filter(([key]) => key !== "year") // Exclude the 'year' field
                    .map(([key, value]) => ({
                        category: data.legend[key],
                        value: value
                    }));

                chart.innerRadius = 150;

                let label = chart.seriesContainer.createChild(am4core.Label);
                label.text = data.data[i].year;
                label.horizontalCenter = "middle";
                label.verticalCenter = "middle";
                label.fontSize = 50;

                // Add and configure Series
                let pieSeries = chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "value";
                pieSeries.dataFields.category = "category";
                pieSeries.labels.template.disabled = true;
                pieSeries.ticks.template.disabled = true;
                chart.invalidateRawData();

                pieSeries.slices.template.propertyFields.fill = "color";
                chart.data.forEach((item, index) => {
                    item.color = am4core.color(colors[index] );
                });

                /* Create legend */
                chart.legend = new am4charts.Legend();

                /* Create a separate container to put legend in */
                let legendContainer = am4core.create(name + i + 'Legend', am4core.Container);
                legendContainer.width = am4core.percent(100);
                legendContainer.height = am4core.percent(100);
                chart.legend.parent = legendContainer;
                chart.legend.labels.template.maxWidth = 100;
                chart.legend.labels.template.truncate = true;

                chart.exporting.menu = new am4core.ExportMenu();
                chart.exporting.menu.align = 'left';
                chart.exporting.menu.verticalAlign = 'top';
            }
        }
    }, []);

    return (
        <>
            <>
                <Grid container spacing={6} className={className}>
                    { data.data.map((item, i) =>
                        <Grid item xs={12} md={6} key={i} style={{padding: "20px"}}>
                            <div key={i} id={name + i}
                                 style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}}></div>
                            <div
                                id={name + i + 'Legend'}
                                style={{
                                    width: showLoader ? '0' : '100%',
                                    height: showLoader ? '0' : height,
                                    maxHeight: '250px',
                                    border: '1px dotted #c99',
                                    margin: '1em 0',
                                    padding: '10px',
                                    overflowX: 'none',
                                    overflowY: 'auto',
                                }}
                            >
                                <div id='legenddiv' style={{height: showLoader ? '0' : '250px'}}></div>
                            </div>
                        </Grid>
                    )
                    }
                </Grid>

            </>

            {showLoader && (
                <Stack spacing={1}>
                    <Skeleton variant='text' sx={{fontSize: '1rem'}}/>
                    <Skeleton variant='rounded' width={'auto'} height={500}/>
                </Stack>
            )}
        </>
    );
};

export default ChartEight;
